import modaal from 'modaal';
import $ from 'jquery';

class SmartSwapsLandingPage {
    constructor() {

    }


    init() {
        this.bindEvents();
    }

    bindEvents() {
        
    }
}

export default SmartSwapsLandingPage;

$(() => {
    const smartSwapsLandingPage = new SmartSwapsLandingPage();
    smartSwapsLandingPage.init();
});